/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BusinessesInputs */

const en_businesses = /** @type {(inputs: BusinessesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Businesses`)
};

const de_businesses = /** @type {(inputs: BusinessesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

/**
* | output |
* | --- |
* | "Businesses" |
*
* @param {BusinessesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const businesses = /** @type {((inputs?: BusinessesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BusinessesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businesses(inputs)
	return de_businesses(inputs)
});